<template>
  <div>
    <label class="col-form-label"
      >Fecha, hora y numero de
      <strong>VUELO DE {{ flightLabel }}</strong></label
    >
    <b-form-row class="mb-1">
      <b-col cols="7" md="5">
        <DateField :disabled="unableEdit" v-model="flightDatetime" />
      </b-col>
      <b-col cols="5" md="3">
        <md-icon icon="access_time" />
        <TimeField :disabled="unableEdit" v-model="flightDatetime" />
      </b-col>
      <b-col cols="12" md="4">
        <b-input-group>
          <b-input-group-prepend v-if="flight.loading">
            <b-button>
              <b-spinner small />
            </b-button>
          </b-input-group-prepend>
          <b-input-group-prepend v-else>
            <b-button
              size="sm"
              variant="info"
              v-b-tooltip.hover
              title="Click para ver la información del vuelo"
              v-if="isThereFlight"
              @click="openFlightData()"
            >
              <md-icon icon="info" />
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              v-if="flightValidationInfo.status === 'none'"
              v-b-tooltip.hover
              title="El vuelo no ha sido validado"
              type="button"
            >
              <md-icon icon="info" />
            </b-button>
            <b-button
              size="sm"
              variant="success"
              v-else
              type="button"
              ref="tooltip-validation-status"
              v-b-tooltip.hover
              :title="
                'El vuelo ha sido validado por ' + flightValidationInfo.status
              "
            >
              <md-icon icon="check_circle" />
            </b-button>
          </b-input-group-prepend>

					<b-form-input
						style="width: auto; display: inline;"
						:disabled="unableEdit"
						type="text"
						size="sm"
						v-model="flightNumber"
						required
					/>
					<b-input-group-append >
						<b-button
							v-if="$hasPermission('reservation.validateFligth')"
							@click="validateFlightData()"
							size="sm"
							variant="info"
						>
							<b-spinner v-if="flight.loading" small />
							<span v-else>Validar</span>
						</b-button>
					</b-input-group-append>
				</b-input-group>
			</b-col>
		</b-form-row>

    <b-form-row
      v-if="
        (flight.showUseFlightOption ||
          flightValidationInfo.status === 'user' ||
          flightValidationInfo.status === 'none') &&
        !flight.loading && $hasPermission('reservation.validateFligth')
      "
    >
      <b-col cols="12" class="text-right">
        <b-form-checkbox
          value="user"
          unchecked-value="none"
          v-model="flightValidationStatus"
        >
          Validación manual del vuelo
        </b-form-checkbox>
      </b-col>
    </b-form-row>
    <b-modal hide-footer ref="modal-view" size="lg" title="Datos de vuelo">
      <TemplateFlightItem
        :flight-data="flightValidationInfo.data"
        v-if="isThereFlight"
        @updateDateTimeFlight=emitUpdateDateTimeFlight
		:typeOfFlight=flightLabel
      ></TemplateFlightItem>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import TemplateFlightItem from "../../../reservations/FlightItem";

import api from "@/api.js";
import { mapFields } from "../helpers/helpers";
import DateField from "../helpers/_dateField";
import TimeField from "../helpers/_timeField";

export default {
	components: {
		TemplateFlightItem,
		DateField,
		TimeField
	},
	props: {
		index: Number,
		unableEdit: Boolean
	},

  data: () => ({
    auxModel: {},
    flight: {
      loading: false,
      showUseFlightOption: false,
      found: false,
    },
  }),

  beforeCreate() {
    this.$options.computed = {
      //El viewModel principal esta en el modulo reservation de vuex store
      ...mapFields({
        fields: [
          "flightDatetime",
          "flightNumber",
          "pickupDatetime",
          "pickup",
          "dropoff",
          "pickupPlaceId",
          "dropoffPlaceId",
          "flightValidationData",
          "flightValidationStatus",
        ],
        fieldArray: "transportServices",
        index: this.$options.propsData.index,
        base: "viewModel",
        mutation: "SET_UPDATE_MODEL_ARRAY",
        module: "reservation",
      }),
      viewModel() {
        return this.$store.state.reservation.viewModel.transportServices[
          this.index
        ];
      },
      flightLabel() {
        return this.pickup.isAirport ? "LLEGADA" : "SALIDA";
      },
      isThereFlight() {
        return (
          (this.flightValidationInfo.data?.number ?? "" !== "") &&
          this.flightValidationInfo.status === "api"
        );
      },
      flightValidationInfo() {
        let originalDate = moment(this.auxModel.flightDatetime).format(
          "yyyy-mm-dd"
        );
        let viewDate = moment(this.flightDatetime).format("yyyy-mm-dd");

        if (
          this.auxModel.pickupPlaceId === this.pickupPlaceId &&
          this.auxModel.dropoffPlaceId === this.dropoffPlaceId &&
          originalDate === viewDate &&
          this.auxModel.flightNumber === this.flightNumber
        ) {
          return {
            data: this.flightValidationData,
            status: this.flightValidationStatus,
          };
        } else if (this.flightValidationStatus === "user") {
          return {
            data: {},
            status: "user",
          };
        } else {
          return {
            data: {},
            status: "none",
          };
        }
      },
    };
  },
  watch: {
    flightDatetime(v) {
      if (this.pickupDatetime === " 00:00") this.pickupDatetime = v;
    },
  },
  mounted() {
    this.auxModel = JSON.parse(JSON.stringify(this.viewModel));
  },
  methods: {
    emitUpdateDateTimeFlight(newDate, newTime){
		//cerramos el modal-dialogo
		this.$refs["modal-view"].hide();
		//actualizamos la fecha
		this.flightDatetime=newDate+" "+newTime;
		console.log(newDate+" "+newTime);
    },
    openFlightData() {
      this.$refs["modal-view"].show();
    },
    validateFlightData() {
      this.flightValidationStatus = "none";
      this.flightValidationData = {};
      this.flight.loading = true;
      this.flight.found = false;
      this.flight.showUseFlightOption = true;
      let params = {
        flightNumber: this.flightNumber,
        flightDate: moment(this.flightDatetime).format("YYYY-MM-DD"),
        pickupRef: this.pickup.type + "-" + this.pickup.id,
        dropoffRef: this.dropoff.type + "-" + this.dropoff.id,
      };
      api(this)
        .get("/reservations/validate-flight", { params: params })
        .then((res) => {
          if (res.data.valid) {
            this.flight.showUseFlightOption = false;
            this.flight.found = true;
            this.flightValidationStatus = "api";
            this.flightValidationData = res.data.flightData;
            this.auxModel = JSON.parse(JSON.stringify(this.viewModel));
          } else {
            this.$root.showAlert("Numero de vuelo no es valido", {
              variant: "danger",
            });
          }
        })
        .finally(() => {
          this.flight.loading = false;
        });
    },
  },
};
</script>
